import s3Storage from '@happylife-a/s3-storage';
import * as helpers from '../../../../helpers';

/**
 * Product UseCase for V2 API
 * @param {{
 *   ProductServiceV2: ReturnType<import('../../../services/v2/ProductServiceV2').default>,
 *   AwsS3Service: ReturnType<import('../../../services/AwsS3Service').default>,
 * }} param0
 */
export default function productUseCaseV2({ ProductServiceV2, AwsS3Service }) {
  const getProducts = (params) => ProductServiceV2.getProducts(params);

  const getProductById = (id) => ProductServiceV2.getProductById(id);

  const createProduct = (input) => ProductServiceV2.createProduct(input);

  const updateProduct = (productId, input) => ProductServiceV2.updateProduct(productId, input);

  const deleteProduct = (productId) => ProductServiceV2.deleteProduct(productId);

  const syncBillzProducts = () => ProductServiceV2.syncBillzProducts();

  const getBillzSyncStatus = () => ProductServiceV2.getBillzSyncStatus();

  const uploadImage = async (file) => {
    const folder = s3Storage.configs.folders.FOLDER_PRODUCTS;
    const { binary, extension } = await helpers.buildBinaryFile(file);

    return AwsS3Service.uploadPublic(binary, {
      folder: folder,
      extension: extension,
    });
  };

  const getProductAiSuggestion = (input) => ProductServiceV2.getProductAiSuggestion(input);

  const uploadMultipleImages = async (files) => {
    const buildFileUploadPromise = (file) => {
      return new Promise(async (resolve) => {
        const folder = s3Storage.configs.folders.FOLDER_PRODUCTS;
        const { binary, extension } = await helpers.buildBinaryFile(file);

        const result = await AwsS3Service.uploadPublic(binary, {
          folder: folder,
          extension: extension,
        });

        resolve(result);
      });
    };

    return Promise.all(files.map((file) => buildFileUploadPromise(file)));
  };

  return {
    getProducts,
    getProductById,
    createProduct,
    updateProduct,
    deleteProduct,
    syncBillzProducts,
    getBillzSyncStatus,
    uploadImage,
    uploadMultipleImages,
    getProductAiSuggestion,
  };
}
